<template>
  <InteractionStep
    :disabled-next="!paid"
    :pending-next="pendingSave"
    @next="onSave">

    <template v-slot:content>
      <div v-if="filesFromPrevSteps && filesFromPrevSteps.length"
           class="step-text" style="margin-bottom: 3rem">
        <h3 class="step-text__title" style="margin: 0">
          {{ $tInteraction('Invitation and letter to the border guard') }}
        </h3>
      </div>

      <div v-if="filesFromPrevSteps && filesFromPrevSteps.length"
           style="margin-bottom:3rem"
           class="step-check-files__list-wrap">
        <div class="step-check-files__list">
          <div v-for="(file) in filesFromPrevSteps"
               :key="file.id"
               class="step-check-files__item">
            <div class="step-check-files__item-file-wrap">
              <FileShow :value="file"
                        class="step-check-files__item-file-el"/>
            </div>
            <!--            <div class="step-check-files__item-buttons">-->
            <!--              <a :href="file.path"-->
            <!--                 download-->
            <!--                 @click.prevent="onDownload(file)"-->
            <!--                 class="base-btn step-check-files__item-btn _download"-->
            <!--              >-->
            <!--                <span class="_one">{{ $tInteraction('Download') }}</span>-->
            <!--                <BaseSvg name="ico-download-2"-->
            <!--                         width="1.4rem"-->
            <!--                         height="1.4rem"/>-->
            <!--              </a>-->
            <!--            </div>-->
          </div>
        </div>
      </div>

      <div class="step-text" style="margin-bottom: 3rem">
        <div v-html="$tInteraction('payment_of_service_fee_text')"
             class="step-text__text text"></div>
      </div>
      <div class="step-insurance">
        <div class="step-insurance__download">
          <h3 class="step-insurance__download-title" style="text-align: center">
            {{ $tInteraction('Upload a receipt here') }}</h3>


          <div v-if="!prevFile && file"
               class="step-insurance__download-file">
            <FileShow :value="file"/>
            <button type="button"
                    @click.prevent="onDeleteFile(file)"
                    class="step-insurance__download-delete">
              <BaseSvg name="ico-trash"/>
            </button>
            <BasePreloader v-if="file.pending"/>
          </div>

          <div v-else-if="prevFile || file"
               class="step-ticket__download-files">
            <div class="step-ticket__download-label">{{ $tInteraction('Already loaded') }}:</div>
            <div class="step-ticket__download-files-list">
              <div v-if="prevFile"
                   key="prevFile"
                   :class="prevFile.reject_reasons || prevFile.reject_reasons_description ? '_warning' : null"
                   class="step-contract__download-file">
                <div class="step-contract__download-file-wrap">
                  <FileShow :value="prevFile.file"
                            class="step-contract__download-file-el"/>
                </div>
                <button type="button"
                        @click.prevent="onDeletePrevFile"
                        class="step-contract__download-delete">
                  <BaseSvg name="ico-trash"/>
                </button>
                <!--                  <BaseInputError :value="createErrors(file)"-->
                <!--                                  class="step-contract__download-file-warning  _warning"/>-->
                <ul v-if="createErrors(prevFile).length"
                    class="step-contract__download-file-warning  _warning  input-error">
                  <li v-for="(error, index) in createErrors(prevFile)"
                      :key="index"
                      class="input-error__item">
                    <template v-if="index === 0">*</template>
                    {{ error }}
                  </li>
                </ul>
                <BasePreloader v-if="prevFile.pending"/>
              </div>
              <div v-if="file"
                   key="file"
                   class="step-contract__download-file">
                <div class="step-contract__download-file-wrap">
                  <FileShow :value="file"
                            class="step-contract__download-file-el"/>
                </div>
                <button type="button"
                        @click.prevent="onDeleteFile"
                        class="step-contract__download-delete">
                  <BaseSvg name="ico-trash"/>
                </button>
                <BasePreloader v-if="file.pending"/>
              </div>
            </div>
          </div>

          <div v-if="!file"
               class="step-insurance__dropzone-wrap">
            <div class="step-contract__dropzone">

              <div @click="$refs.fileInput.click()"
                   ref="dropzone"
                   :class="{'_drag-over': dragoverMixin}"
                   class="step-contract__dropzone-btn">
                <input ref="fileInput"
                       class="d-none"
                       type="file"
                       multiple
                       @change="onFilesInputMixin"
                >
                <BaseSvg name="ico-plus"
                         height="2.7rem"/>
                <span>{{ $tInteraction('Upload') }}</span>
              </div>

              <span class="step-contract__dropzone-or">{{ $tInteraction('or') }}</span>

              <div @click.prevent="onShowPopup"
                   class="step-contract__dropzone-btn">
                <BaseSvg name="ico-photo"
                         width="3rem"
                         height="2.7rem"/>
                <span>{{ $tInteraction('To photograph') }}</span>
              </div>
              <BasePreloader v-if="pendingUpload"/>
            </div>
            <BaseAlert :value="errorMixin"/>
          </div>

          <transition name="fade">
            <div v-if="showPopup"
                 class="step-insurance__popup photo-popup">
              <button type="button"
                      class="photo-popup__close"
                      @click.prevent="onClosePopup">
                <BaseSvg name="ico-close"/>
              </button>

              <div class="photo-popup__content">
                <img src="../../../assets/img/svg/phone-popup.svg"
                     alt="phone"
                     class="photo-popup__img">
                <h3 class="photo-popup__title">{{
                    $tInteraction('To take a photo, open the site on your mobile device')
                  }}</h3>
                <div class="photo-popup__text text">
                  <p>{{ $tInteraction('take_photo_mobile_text') }}</p>
                </div>

                <button type="button"
                        @click.prevent="onClosePopup"
                        class="photo-popup__btn base-btn base-btn--outline-dark">
                  <span class="base-btn__text">{{ $tInteraction('Continue booting from PC') }}</span>
                </button>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <div class="step-options" style="margin-top: 3rem">
        <div class="step-options__inner">
          <label :class="!file ? '_disabled' : null"
                 class="step-options__item">
            <input type="checkbox"
                   name="type-option"
                   :disabled="!file"
                   v-model="paid"
                   hidden>
            <span class="step-options__item-mark">
              <BaseSvg name="ico-check"/>
            </span>
            <span class="step-options__item-inner">
              <span>{{ $tInteraction('Paid up') }}</span>
            </span>
          </label>
        </div>
      </div>

      <div class="step-text" style="margin-top: 3rem; margin-bottom: 2rem">
        <h3 class="step-text__title" style="margin: 0">
          {{ $tInteraction('Pay online:') }}
        </h3>
        <div class="step-insurance__logo-list">
          <a v-for="logo in logoList"
             :key="logo.name"
             :href="logo.url"
             target="_blank"
             class="step-insurance__logo-list-item">
            <img :src="logo.logo" :alt="logo.name">
          </a>
        </div>
      </div>

      <!--      <div class="step-text" style="margin: 3rem 0">-->
      <!--        <div class="step-text__title">-->
      <!--          <p>{{ $tInteraction('Select submission of documents type') }}</p>-->
      <!--        </div>-->
      <!--        <BaseRadioList v-model="type"-->
      <!--                       :options="list"-->
      <!--                       textKey="title"-->
      <!--                       class="step-type__list  _row"/>-->
      <!--      </div>-->

      <BaseAlert :value="error" class="step-insurance__error  _error"/>
    </template>
  </InteractionStep>
</template>

<script>
  import InteractionStep from '../InteractionStep'
  import fileUploadMixin from '../../../mixins/fileUploadMixin'
  import FileShow from '../../FileShow'
  import {http} from "../../../axios"
  import interactionStepMixin from "@/mixins/interactionStepMixin"
  // import windowSizeMixin from '../../../mixins/windowSizeMixin'
  // import {blockScroll, unBlockScroll} from '../../../helpers/scroll'

  export default {
    name: 'InteractionStepInsurance',
    components: {
      InteractionStep,
      FileShow
    },
    mixins: [
      fileUploadMixin,
      interactionStepMixin,
      // windowSizeMixin
    ],
    data() {
      return {
        pendingSave: false,
        pendingUpload: false,
        showPopup: false,
        pendingIframe: true,
        timer: null,
        uploadFileMethodNameMixin: ['onUploadFiles'],
        file: null,
        error: null,
        errorUpload: null,
        paid: false,


        type: null,
        list: [
          {
            id: 1,
            title: this.$tInteraction('Visit visa center'),
            key: 'visa_center'
          },
          {
            id: 2,
            title: this.$tInteraction('By "Nova Poshta"'),
            key: 'by_nova_poshta'
          },
        ],

        prevFile: null
      }
    },
    computed: {
      stepData() {
        return this.$store.state.interaction.stepData
      },
      logoList() {
        return this.stepData.data.payment_methods
      },
      filesFromPrevSteps() {
        return this.stepData.data.invitation
      },
      currentLang() {
        const lang = this.$store.state.locales[this.$store.state.currentLocale]

        return lang.regional.substring(0, 2)
      },
    },
    methods: {
      onUploadFiles(files) {
        this.errorUpload = null
        this.pendingUpload = true
        const formData = new FormData()
        formData.append('file', files[0])

        const step = this.$store.state.interaction.step

        http.post(`/api/new-interaction/${this.$route.params.id}/upload/${step}`, formData).then(({data}) => {
          this.file = data.data
        }).catch(e => {
          this.errorUpload = this.handleInteractionError(e, false)
        }).finally(() => {
          this.pendingUpload = false
        })
      },
      onSave() {
        this.error = null
        this.pendingSave = true
        const step = this.$store.state.interaction.step

        return http.post(`/api/new-interaction/${this.$route.params.id}/${step}`).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction', this.$route.params.id)
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      },
      onShowPopup() {
        // if(this.windowSizeMixin.width < 768) {
        //   blockScroll()
        // }
        this.showPopup = true
      },
      onClosePopup() {
        // unBlockScroll()
        this.showPopup = false
      },
      onDeleteFile() {
        const file = this.file
        this.$set(file, 'pending', true)

        http.delete(`/api/new-interaction/${this.$route.params.id}/${file.id}`).then(() => {
          this.file = null
        }).catch(e => {
          this.errorUpload = this.handleInteractionError(e, false)
          this.$set(file, 'pending', false)
        })
      },
      onDeletePrevFile() {
        const file = this.prevFile
        this.$set(file, 'pending', true)

        http.delete(`/api/new-interaction/${this.$route.params.id}/${file.file.id}`).then(() => {
          this.prevFile = null
        }).catch(e => {
          this.errorUpload = this.handleInteractionError(e, false)
          this.$set(file, 'pending', false)
        })
      },
      // checkMob() {
      //   clearTimeout(this.timer)
      //   this.timer = setTimeout(() => {
      //     if(this.showPopup && this.windowSizeMixin.width > 767) {
      //       this.onClosePopup()
      //     }
      //   }, 200)
      // },
      createErrors(file) {
        const a = []
        if (file.reject_reasons) a.push(file.reject_reasons.name)
        if (file.reject_reasons_description) a.push(file.reject_reasons_description)

        return a
      }
    },
    created() {
      const file = this.$store.state.interaction.stepData.data.service_fee_file
      if (!file || !file.file) return
      if (file.reject_reasons || file.reject_reasons_description) {
        this.prevFile = file
      } else {
        this.file = file
      }
    }
    // mounted() {
    //   window.addEventListener('resize', this.checkMob)
    // },
    // beforeDestroy() {
    //   this.onClosePopup()
    //   window.removeEventListener('resize', this.checkMob)
    // }
  }
</script>

<style>

</style>
